import React, {
  useState,
} from 'react';
import {
  FormControl,
  OutlinedInput,
  InputLabel,
  FormHelperText,
  InputAdornment,
  IconButton,
  TextField
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';

const useStyles = makeStyles((theme) => ({
  secret: {
    fontFamily: 'Password',
  },
}));
export default function SecretInput({
  label,
  name,
  value,
  onChange,
  error,
  helperText,
  ariaLabel,
  disabled,
}) {

  const [showSecret, setShowSecret] = useState(false);
  const classes = useStyles();

  return (
    <FormControl
      style={{ width: '100%' }}
      variant='outlined'
      disabled={disabled}
    >
      <InputLabel htmlFor="filled-adornment-password">{label}</InputLabel>
      <OutlinedInput
        type='text'
        inputProps={{
          inputMode: 'numeric',
        }}
        name={name}
        value={value}
        onChange={onChange}
        error={error}
        className={!showSecret ? classes.secret : null}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label={ariaLabel}
              onClick={() => setShowSecret(!showSecret)}
            >
              {showSecret ? <VisibilityIcon /> : <VisibilityOffIcon />}
            </IconButton>
          </InputAdornment>
        }
        labelWidth={110}
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
}